// extracted by mini-css-extract-plugin
export var orderSummary = "_rj-0";
export var showMoreLessButton = "_rj-1";